// eslint-disable-next-line no-restricted-imports -- the single blessed wrapper around useResource
import { useResource } from 'pulse/react';
import { useHttpClient } from './HttpClientContext';

/**
 * `useResource` with the HttpClientContext client injected automatically.
 *
 * Resource reads must thread the context httpClient through to the resolver;
 * forgetting it silently falls back to pulse's singleton client, which breaks
 * embedded callers (e.g. SalesSidebar) that inject their own apiClient. Use
 * this everywhere instead of calling `useResource` directly. An `httpClient`
 * passed in `options` is intentionally overridden by the context client.
 */
export const useHttpResource = (resource, options) => {
  const httpClient = useHttpClient();
  return useResource(resource, Object.assign({}, options, {
    httpClient
  }));
  // The cast below forwards useResource's exact overloaded, generic signature
  // to callers. Without it the wrapper collapses to one non-generic signature
  // and `data` infers as `unknown` at every call site.
};